export const ATTACHMENTS = ['attachments'];
export const COMMON_MESSAGE = ['commonMessage'];
export const EDITOR_STATE = ['editorState'];
export const METADATA = ['metadata'];
export const REPLY_ID = ['replyId'];
export const TIMESTAMP = ['timestamp'];
export const VERSION = ['version'];
export const VID = ['vid'];
export const COMMON_MESSAGE_RECIPIENTS = [...COMMON_MESSAGE, 'recipients'];
export const COMMON_MESSAGE_SENDERS = [...COMMON_MESSAGE, 'senders'];